<template>
  <div
    class="min-h-screen bg-gray-900 flex flex-col sm:justify-start md:justify-start lg:justify-start pt-4 sm:pt-8 md:pt-12 sm:px-6 lg:px-8 overflow-y-auto"
  >
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <h2 class="text-center text-2xl md:text-3xl font-extrabold text-white">
        Prijavi se na svoj nalog
      </h2>
      <p class="mt-2 text-center text-sm text-gray-400">
        Ili
        <router-link
          to="/register"
          class="font-medium text-indigo-400 hover:text-indigo-300"
        >
          kreiraj novi nalog
        </router-link>
      </p>
    </div>

    <div class="mt-6 sm:mx-auto sm:w-full sm:max-w-md">
      <div
        class="bg-gray-800 py-8 px-6 shadow-md sm:rounded-lg sm:px-10 border border-gray-700"
      >
        <LoginForm @login-success="onLoginSuccess" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import LoginForm from '@/components/auth/LoginForm.vue';

export default defineComponent({
  name: 'LoginView',
  components: {
    LoginForm,
  },
  setup() {
    const router = useRouter();
    const store = useStore();

    const onLoginSuccess = async () => {
      console.log('Login uspešan!');

      // First set the user as logged in
      store.dispatch('auth/setLoggedIn', true);

      // Sačuvamo redirectPath odmah nakon uspešnog logina
      const redirectPath = localStorage.getItem('redirectAfterLogin');
      console.log('Redirect path:', redirectPath); // Dodajte ovo za debugging

      // Then immediately fetch the user data
      try {
        await store.dispatch('auth/fetchCurrentUser');
        console.log('User data fetched successfully');

        // Koristimo sačuvani redirectPath
        if (redirectPath && redirectPath !== '/login') {
          console.log('Redirecting to:', redirectPath);
          localStorage.removeItem('redirectAfterLogin');
          router.push(redirectPath);
        } else {
          // Ako nema redirect patha ili je to /login, idemo na home
          console.log('No redirect path or login path, going to home');
          localStorage.removeItem('redirectAfterLogin');
          router.push('/');
        }
      } catch (error) {
        console.error('Error fetching user data after login:', error);
        // U slučaju greške, opet proveravamo redirect path
        if (redirectPath && redirectPath !== '/login') {
          localStorage.removeItem('redirectAfterLogin');
          router.push(redirectPath);
        } else {
          localStorage.removeItem('redirectAfterLogin');
          router.push('/');
        }
      }
    };

    return {
      onLoginSuccess,
    };
  },
});
</script>

<style>
html,
body {
  height: 100%;
}

/* Omogući scrollovanje na manjim uređajima kad je potrebno */
@media (max-height: 800px) {
  html,
  body {
    overflow-y: auto;
  }
}

/* Zadrži fixed poziciju na većim ekranima */
@media (min-height: 801px) {
  html,
  body {
    overflow-y: auto;
  }

  /* Prilagođavanje vertikalnog razmaka na različitim veličinama ekrana */
  .min-h-screen {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
}
</style>
<style scoped>
/* Ovo će sakriti scrollbar samo na ovoj komponenti */
:deep(body) {
  overflow: hidden !important;
}
</style>
